import { AccessState } from './access'

// 三態各自的文案。🔴 差別不在措辭而在**使用者接下來要做什麼**，
// 所以三者的行動按鈕也不同——沒有行動的錯誤畫面等於死路。
const NOTICE: Record<Exclude<AccessState, 'ok'>, {
  title: string
  body: string
  action?: { label: string; href: string }
  hint?: string
}> = {
  unauthenticated: {
    title: '請先登入揪里嗨',
    body: 'AI 管家需要透過揪里嗨帳號使用。回到揪里嗨完成登入後再回來這裡即可。',
    hint: '登入狀態有時效，放著一段時間沒用也會需要重新登入。',
  },
  forbidden: {
    title: '目前無法使用 AI 管家',
    body: '你的帳號沒問題，但目前沒有這項功能的使用權限：可能是單位尚未開通，或帳號尚未獲得授權。',
    hint: '需要開通請聯絡客服，這不是重新登入能解決的。',
  },
  unavailable: {
    title: '服務暫時無法使用',
    body: '系統現在確認不了你的權限，這通常是暫時的。',
    action: { label: '重新整理', href: '' },
    hint: '若持續出現，請聯絡客服。',
  },
}

// loginUrl 由伺服器在執行期提供；取不到時登入按鈕停用並提示，不猜網域
export function AccessNotice({ state, loginUrl = null }: { state: Exclude<AccessState, 'ok'>, loginUrl?: string | null }) {
  const base = NOTICE[state]
  const notice = state === 'unauthenticated' && loginUrl
    ? { ...base, action: { label: '前往揪里嗨登入', href: loginUrl } }
    : base
  const loginUnavailable = state === 'unauthenticated' && !loginUrl
  return (
    <div className="access-notice">
      <div className="access-card">
        <p className="access-brand">AI 管家</p>
        <h1>{notice.title}</h1>
        <p className="access-body">{notice.body}</p>
        {notice.action && (
          <button
            type="button"
            onClick={() => {
              if (notice.action?.href) window.location.href = notice.action.href
              else window.location.reload()
            }}
          >
            {notice.action.label}
          </button>
        )}
        {loginUnavailable && (
          <button type="button" disabled>前往揪里嗨登入</button>
        )}
        {notice.hint && <p className="access-hint">{notice.hint}</p>}
      </div>
    </div>
  )
}
